export enum WebhookStatusEnum {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export interface WebhookInterface {
  id: string;
  application: string;
  consumerId: string;
  unifiedApi: string;
  description: string;
  deliveryUrl: string;
  status: WebhookStatusEnum;
  events: string[];
  createdAt: string;
  updatedAt: string;
}

export interface WebhookResponseInterface {
  data: WebhookInterface[];
}

export interface WebhookDeleteResponseInterface {
  data: WebhookInterface;
}

export type AddWebhookRequestType = Pick<
  WebhookInterface,
  'unifiedApi' | 'description' | 'deliveryUrl' | 'status' | 'events' | 'application' | 'id'
>;
